'use client';
import { useCart } from '@shopify/hydrogen-react';
import CartIconButton from '@repo/ui/src/components/CartIconButton';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';

const NavbarShoppingCart = () => {
  const { totalQuantity, status } = useCart();
  const { push } = useModal(ModalID.cart);

  if (status === 'uninitialized') {
    return null;
  }

  return <CartIconButton count={totalQuantity ?? 0} onClick={push} badgeClassName="bg-brand-300" />;
};

export default NavbarShoppingCart;
